import { useReadyReportWorklist } from './pathology.queries';
import { readyReportStatusOptions } from './pathology.utils';
import { WorklistPage } from './WorklistPage';

export const ReadyReportPage = () => (
  <WorklistPage
    eyebrow="Investigation"
    title="Ready Report"
    description="Reports that are complete and ready to share, across Pathology, Non-Pathology, and Radiology."
    useWorklist={useReadyReportWorklist}
    actionLabel="Deliver"
    action="deliver-report"
    emptyTitle="No reports ready yet"
    emptyMessage="Reports appear here once a test has been marked report-generated."
    statusOptions={readyReportStatusOptions}
    defaultStatus="report-generated"
  />
);
